/**
 * Unwrap description when API stores JSON wrapper { value | html }.
 * @param {unknown} raw
 * @returns {string}
 */
export function unwrapDescriptionString(raw) {
  if (raw == null) return "";
  if (typeof raw !== "string") return typeof raw === "object" ? JSON.stringify(raw) : String(raw);
  const t = raw.trim();
  if (!t.startsWith("{")) return raw;
  try {
    const parsed = JSON.parse(t);
    if (parsed && typeof parsed === "object") {
      return parsed.value ?? parsed.html ?? raw;
    }
  } catch {
    /* keep string */
  }
  return raw;
}
